import {ToggleButtonWithIcon} from '@gongxigames/framework/core/fragments/react';
import React from 'react';

export type AutoplayToggleButtonProps = {
    onToggle: (value: boolean) => void;
    value: boolean | null;
    disabled?: boolean;
    visible?: boolean;
    name?: string;
    x?: number;
    y?: number;
};

export function AutoplayToggleButton(props: AutoplayToggleButtonProps): JSX.Element {
    return (
        <ToggleButtonWithIcon
            onIcon={{
                up: 'radiobutton_on_green_normal',
                down: 'radiobutton_on_green_pressed',
                over: 'radiobutton_on_green_focused',
                disabled: 'radiobutton_on_green_disabled'
            }}
            offIcon={{
                up: 'radiobutton_off_normal',
                down: 'radiobutton_off_pressed',
                over: 'radiobutton_off_focused',
                disabled: 'radiobutton_off_disabled'
            }}
            {...props}
        />
    );
}
